import ko from 'knockout';
import axios from "axios";
import {Dropdown} from "bootstrap";
import { initLoadMore } from './catalog/load-more';

function SortByToFriendly(sortOn) {
    switch (sortOn) {
        case "asc":
            return "Price: Low to High";
        case "desc":
            return "Price: High to Low";
        case "best":
            return "Best Selling";
    }
}

var Filters = {

    SortByToFriendly: function(sortOn) {
        return SortByToFriendly(sortOn);
    },

    // this works, however there is a bit of a mish mash of using knockout and jquery for different events etc,
    // could probably do with a little refactor to use pure knockout if feasible
    init: async function (data, sortByData) {
        
        $(".sortBy").on('click', function() {
           var sortOn = $(this).attr('data-sortOn');

            sortByData(sortOn);
            
            $(".sortByText").html(SortByToFriendly(sortByData()));
            
            updateFromFilters();
            
            var el = document.getElementById('sortByDropdown');
            var dd = Dropdown.getInstance(el);
            
            dd.hide();
            return false;
        });
        
        $("#btn-clear-filters").on('click', function (e) {
            data.removeAll();
            $(".facet-checkbox").prop('checked', false);
            
            updateFromFilters();
        });
        
        $("#btn-toggle-filters, #filters-mobile-close").on('click', function(e) {
            e.preventDefault()
            
            $("#sideFilters").toggleClass('d-none').toggleClass('d-flex');
            $("#catalogContainer").toggleClass('col-lg-9').toggleClass('col-lg-12');
        })
        
        $("#products-browse").on('click', ".selected-filter-tag", function() {
            let facetNameSlug = $(this).attr('data-facetNameSlug');
            let facetValueSlug = $(this).attr('data-facetValueSlug');
            
            $("#facet_" + facetNameSlug + "_" + facetValueSlug).prop('checked', false);

            // remove from selected filter
            data.remove(function(item){
                return (ko.unwrap(item.FacetNameSlug) == facetNameSlug && ko.unwrap(item.FacetValueSlug) == facetValueSlug);
            })
            
            updateFromFilters();
        });
        
        $(".facet-checkbox").on('change', function(item) {
            var checkbox = item.currentTarget as HTMLInputElement;
            
            let checked = checkbox.checked;
            
            if (checked) {
                // add to selected filters
                
                var selectedFilter = {
                    FacetName: checkbox.dataset.facetname,
                    FacetNameSlug: checkbox.dataset.facetslug,
                    FacetValue: checkbox.dataset.facetvalue,
                    FacetValueSlug: checkbox.dataset.facetvalueslug
                };
                
                data.push(selectedFilter);
            }
            else {
                //data.removeAll();
                
                // remove from selected filter
                data.remove(function(item){
                    return (ko.unwrap(item.FacetNameSlug) == checkbox.dataset.facetslug && ko.unwrap(item.FacetValueSlug) == checkbox.dataset.facetvalueslug);
                })
            }
            updateFromFilters();
        })

        async function updateFromFilters() {
            // get all selected facets
            let facets = [];
            $(".facet-checkbox").each(function(index, checkElem:HTMLInputElement) {
                if (checkElem.checked) {
                    facets.push('--' + checkElem.dataset.facetslug + '_' + checkElem.dataset.facetvalueslug);
                }
            })
            facets.sort();

            var form = $("#filterform");
            var actionUrl = form.attr("action");
            var baseActionUrl = form.attr('data-baseactionurl');
            var query = form.attr('data-baseactionquery');
            
            var postData = {
                facetFilterValues: facets,
                sortBy: sortByData()
            }

            // loading
            $("#catalogContainer,#facetFilters .accordion-body").css({'opacity': 0.5});
            
            if (query != null)
                actionUrl += '?query=' + query;
            
            try {
                var result = await axios.post(actionUrl, postData);
                
                var pushUrl = facets.join("");
                var url;
                if (pushUrl != '') {
                    url = new URL(baseActionUrl + '/' + pushUrl + '/' + sortByData(), window.location.origin);
                }
                else {
                    url = new URL(baseActionUrl + '/' + sortByData(), window.location.origin);
                }
                
                if(query != null)
                    url.searchParams.set("query", query);

                history.pushState({}, "", url);

                // Replace entire catalog container content (not just the row)
                // The partial includes products, load more button, and SEO links
                $("#catalogContainer").html(result.data);

                // Re-initialize load more button after HTML replacement
                initLoadMore();

                // loading
                $("#catalogContainer,#facetFilters .accordion-body").css({'opacity': 1});
            }
            catch(err) {

            }
        }
    }
}

export {Filters as default};